import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/wel/${owner}` , { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/wel/${id}` , { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/wel/${owner}`, data , { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/wel/${id}`, data , { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/wel/${id}` , { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/wel` , { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/wel?title=${title}` , { headers: authHeader() });
};

const WelService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default WelService;
